/* Golden Story — cart drawer, sticky buy bar & book preview lightbox
   Vanilla JS, geen dependencies. Valt netjes terug op normale formulier-
   navigatie als fetch() om wat voor reden dan ook faalt. */
(function () {
  'use strict';

  var CART_ADD_URL = '/cart/add.js';
  var CART_CHANGE_URL = '/cart/change.js';
  var CART_URL = '/cart.js';

  /* Gratis boekenlegger en cadeauverpakking tellen niet mee in het getal dat
     de klant ziet. Zelfde logica als snippets/gs-cart-count.liquid. */
  var BOOKMARK_VARIANT_ID = '58742938173814';
  var UNCOUNTED_HANDLES = ['cadeauverpakking'];

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function visibleCount(cart) {
    var n = cart.item_count || 0;
    (cart.items || []).forEach(function (item) {
      if (String(item.variant_id) === BOOKMARK_VARIANT_ID || UNCOUNTED_HANDLES.indexOf(item.handle) > -1) n -= item.quantity;
    });
    return n < 0 ? 0 : n;
  }

  /* ----------------------------------------------------------------
     Cart drawer — schuift uit vanaf het ronde knopje rechtsboven.
  ---------------------------------------------------------------- */
  var drawer = qs('[data-cart-drawer]');

  /* Scroll-lock die ook op iOS Safari werkt. */
  var lockedScrollY = 0;
  var isScrollLocked = false;

  function lockBodyScroll() {
    if (isScrollLocked) return;
    isScrollLocked = true;
    lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = (lockedScrollY * -1) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockBodyScroll() {
    if (!isScrollLocked) return;
    isScrollLocked = false;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
  }

  function openDrawer() {
    document.body.classList.add('cart-drawer-open');
    lockBodyScroll();
  }
  function closeDrawer() {
    document.body.classList.remove('cart-drawer-open');
    unlockBodyScroll();
  }

  function refreshDrawer(thenOpen) {
    var url = window.location.pathname + (window.location.pathname.indexOf('?') > -1 ? '&' : '?') + 'section_id=cart-drawer';
    return fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var fresh = temp.querySelector('[data-cart-drawer]');
        if (fresh && drawer && drawer.parentNode) {
          drawer.parentNode.replaceChild(fresh, drawer);
          drawer = fresh;
          bindDrawerEvents();
        }
        if (thenOpen) openDrawer();
      })
      .catch(function () { if (thenOpen) openDrawer(); });
  }

  function updateCartCount() {
    fetch(CART_URL)
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = visibleCount(cart);
        qsa('[data-cart-count]').forEach(function (el) { el.textContent = count; });
        var badge = qs('.floating-cart__badge');
        if (badge) {
          badge.textContent = count;
          badge.hidden = count === 0;
        }
      })
      .catch(function () {});
  }

  function removeLine(key) {
    return fetch(CART_CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function swapForCombi(removeKeyRaw, addVariantId, btn) {
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Bezig…';

    /* removeKeyRaw can be a single line key or a comma-separated list
       (e.g. when swapping two paar-sets or four losse boeken for the
       familie-set in one go). Remove sequentially to avoid racing the
       cart API, then add the new variant. */
    var removeKeys = (removeKeyRaw || '')
      .split(',')
      .map(function (k) { return k.trim(); })
      .filter(Boolean);

    var removeStep = removeKeys.reduce(function (chain, key) {
      return chain.then(function () { return removeLine(key); });
    }, Promise.resolve());

    removeStep
      .then(function () {
        return fetch(CART_ADD_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: addVariantId, quantity: 1 })
        });
      })
      .then(function () {
        updateCartCount();
        return refreshDrawer(true);
      })
      .catch(function () { window.location.reload(); })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  function bindDrawerEvents() {
    if (!drawer) return;
    qsa('[data-cart-drawer-close]', drawer).forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    qsa('[data-cart-swap-combi]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        swapForCombi(btn.getAttribute('data-remove-key'), btn.getAttribute('data-add-variant'), btn);
      });
    });

    qsa('[data-cart-drawer-line]', drawer).forEach(function (line) {
      var key = line.getAttribute('data-key');
      var valueEl = qs('[data-drawer-qty-value]', line);

      qsa('[data-drawer-qty]', line).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var current = parseInt(valueEl.textContent, 10) || 0;
          var next = btn.getAttribute('data-drawer-qty') === 'plus' ? current + 1 : Math.max(0, current - 1);
          changeLine(key, next);
        });
      });

      var removeBtn = qs('[data-drawer-remove]', line);
      if (removeBtn) {
        removeBtn.addEventListener('click', function () { changeLine(key, 0); });
      }
    });
  }

  function changeLine(key, quantity) {
    fetch(CART_CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () { updateCartCount(); return refreshDrawer(true); })
      .catch(function () { window.location.reload(); });
  }

  function isAddToCartForm(form) {
    return form && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') > -1;
  }

  function celebrateCartButton() {
    var cartBtn = qs('.header-cart');
    if (!cartBtn) return;
    cartBtn.classList.remove('header-cart--bump');
    void cartBtn.offsetWidth; /* herstart de animatie */
    cartBtn.classList.add('header-cart--bump');
    var count = qs('.header-cart__count', cartBtn);
    if (count) {
      count.classList.remove('header-cart__count--pop');
      void count.offsetWidth;
      count.classList.add('header-cart__count--pop');
    }
  }

  function handleAddToCartSubmit(e) {
    var form = e.target.closest ? e.target.closest('form') : null;
    if (!form) form = e.target;
    if (!isAddToCartForm(form)) return;

    e.preventDefault();
    var submitBtn = qs('button[type="submit"]', form);
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Toevoegen…';
    }

    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        if (submitBtn) {
          submitBtn.textContent = 'Toegevoegd ✓';
          submitBtn.classList.add('btn--added');
        }
        celebrateCartButton();
        updateCartCount();
        return refreshDrawer(true);
      })
      .then(function () {
        if (submitBtn) {
          setTimeout(function () {
            submitBtn.disabled = false;
            submitBtn.classList.remove('btn--added');
            submitBtn.textContent = originalText;
          }, 1500);
        }
      })
      .catch(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('btn--added');
          submitBtn.textContent = originalText;
        }
        form.submit();
      });
  }

  /* true = capture-fase: het thema houdt het formulier tegen voordat Shopify het
     als losse 'toegevoegd aan winkelwagen' telt. Anders telden TikTok, Meta en
     Google elke klik dubbel (formulier + cart/add.js). */
  document.addEventListener('submit', handleAddToCartSubmit, true);

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-drawer-toggle]');
    if (toggle) {
      e.preventDefault();
      if (document.body.classList.contains('cart-drawer-open')) {
        closeDrawer();
      } else {
        refreshDrawer(true);
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  bindDrawerEvents();
  document.addEventListener('gs:bookmark-updated', function () { updateCartCount(); refreshDrawer(false); });

  /* ----------------------------------------------------------------
     Sticky "koop nu"-balk op mobiel
  ---------------------------------------------------------------- */
  var stickyBar = qs('[data-sticky-buy]');
  var mainBuyBtn = qs('[data-main-buy-btn]');

  if (stickyBar && mainBuyBtn && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var aboveViewport = entry.boundingClientRect.top < 0;
        if (!entry.isIntersecting && aboveViewport) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(mainBuyBtn);
  }

  // Houd variant-keuze en prijs in de sticky balk gelijk aan het hoofdformulier.
  var variantSelect = qs('.variant-select select');
  var stickyIdInput = qs('[data-sticky-buy-id]');
  var stickyPrice = qs('[data-sticky-buy-price]');

  if (variantSelect && stickyIdInput) {
    variantSelect.addEventListener('change', function () {
      stickyIdInput.value = variantSelect.value;
      var selectedOption = variantSelect.options[variantSelect.selectedIndex];
      var price = selectedOption && selectedOption.getAttribute('data-price');
      if (stickyPrice && price) {
        stickyPrice.textContent = price;
      }
    });
  }

  /* ----------------------------------------------------------------
     "Kijk in het boek" — lightbox voor voorbeeldpagina's
  ---------------------------------------------------------------- */
  var previewImages = qsa('[data-book-preview-trigger]');
  var lightbox = qs('[data-book-preview-lightbox]');

  if (previewImages.length && lightbox) {
    var lightboxImg = qs('[data-book-preview-lightbox-img]', lightbox);
    var lightboxCaption = qs('[data-book-preview-lightbox-caption]', lightbox);
    var currentIndex = 0;

    function showImage(index) {
      currentIndex = (index + previewImages.length) % previewImages.length;
      var trigger = previewImages[currentIndex];
      lightboxImg.src = trigger.getAttribute('data-full-src') || trigger.src;
      lightboxImg.alt = trigger.alt || '';
      lightboxCaption.textContent = trigger.getAttribute('data-caption') || '';
    }

    previewImages.forEach(function (img, index) {
      img.addEventListener('click', function () {
        showImage(index);
        lightbox.classList.add('is-open');
      });
    });

    qsa('[data-book-preview-close]', lightbox).forEach(function (el) {
      el.addEventListener('click', function () { lightbox.classList.remove('is-open'); });
    });
    var prevBtn = qs('[data-book-preview-prev]', lightbox);
    var nextBtn = qs('[data-book-preview-next]', lightbox);
    if (prevBtn) prevBtn.addEventListener('click', function () { showImage(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showImage(currentIndex + 1); });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') lightbox.classList.remove('is-open');
      if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
      if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    });
  }
})();
